module.exports = __webpack_public_path__ + "static/media/bg_01.319e4fb3.jpg";